import { useMutation, useQueryClient } from "@tanstack/react-query";
import { generatePath, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

import { ADMIN_MANAGEMENT_COMPANIES_ENDPOINTS, AdminManagementCompaniesService } from "@/service/api/admin-management-companies";
import { UpdateAdminManagementCompanyDto } from "@/service/dto/admin-management-companies";
import { getApiErrorMessage } from "@/modules/common/utils/apiError";
import { ROUTES } from "@/routes/constants/routes";

interface UpdateManagementCompanyParams {
  id: string;
  data: UpdateAdminManagementCompanyDto;
}

const useUpdateManagementCompany = () => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, data }: UpdateManagementCompanyParams) => AdminManagementCompaniesService.updateManagementCompany(id, data),
    onError: (error) => {
      toast.error(getApiErrorMessage(error, "Erro ao atualizar gestora. Tente novamente mais tarde."), {
        toastId: "update_management_company_error",
      });
    },
    onSuccess: (_data, { id }) => {
      toast.success("Gestora atualizada com sucesso!");
      navigate(generatePath(ROUTES.MANAGER.DETAILS, { id }));
      queryClient.invalidateQueries({ queryKey: [ADMIN_MANAGEMENT_COMPANIES_ENDPOINTS.GET_MANAGEMENT_COMPANIES] });
      queryClient.invalidateQueries({ queryKey: [ADMIN_MANAGEMENT_COMPANIES_ENDPOINTS.GET_MANAGEMENT_COMPANY(id)], exact: true });
      queryClient.invalidateQueries({ queryKey: [ADMIN_MANAGEMENT_COMPANIES_ENDPOINTS.GET_MANAGER_USERS(id)] });
      queryClient.invalidateQueries({ queryKey: [ADMIN_MANAGEMENT_COMPANIES_ENDPOINTS.GET_TOTALIZERS] });
      queryClient.invalidateQueries({ queryKey: [ADMIN_MANAGEMENT_COMPANIES_ENDPOINTS.GET_OWNERS] });
    },
  });
};

export default useUpdateManagementCompany;
